import React from 'react';
import { Box } from '@chakra-ui/react';
import ProfileHeader from '../ProfileHeader';
import { useWallet } from '@solana/wallet-adapter-react';

/**
 * Profile section component
 * Displays user profile information
 */
const ProfileSection = () => {
  const wallet = useWallet();
  
  return (
    <Box
      px={{ base: 3, md: 4 }}
      py={4}
      bg="rgba(16, 16, 16, 0.9)"
      borderRadius="xl"
      border="1px solid rgba(153, 69, 255, 0.3)"
      position="relative"
      overflow="visible"
      boxShadow="0 0 40px rgba(153, 69, 255, 0.3)"
      _before={{
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bg: "radial-gradient(circle at center, rgba(153, 69, 255, 0.15), transparent 70%)",
        pointerEvents: "none",
        zIndex: 0
      }}
    >
      <Box position="relative" zIndex={1}>
        <ProfileHeader walletAddress={wallet.publicKey?.toString()} />
      </Box>
    </Box>
  );
};

export default ProfileSection;
